"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalDialog = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = require("../Modal");
var _ModalDialogContent = require("./ModalDialogContent");
var _Box = require("../Box");
var _useDidMount = require("../../utils/useDidMount");
var _Theme = require("../../Theme");
var _excluded = ["children", "footer", "hasLogo", "leftPanel", "onClose", "rightPanel", "title", "header"],
  _excluded2 = ["width"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ModalDialog = function ModalDialog(_ref) {
  var children = _ref.children,
    footer = _ref.footer,
    hasLogo = _ref.hasLogo,
    leftPanel = _ref.leftPanel,
    onClose = _ref.onClose,
    rightPanel = _ref.rightPanel,
    title = _ref.title,
    header = _ref.header,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isMounted = (0, _useDidMount.useDidMount)({
    clearCallStack: true
  });
  var _splitBoxProps = (0, _Box.splitBoxProps)(rest),
    _splitBoxProps2 = _slicedToArray(_splitBoxProps, 2),
    _splitBoxProps2$ = _splitBoxProps2[0],
    width = _splitBoxProps2$.width,
    boxProps = _objectWithoutProperties(_splitBoxProps2$, _excluded2),
    modalProps = _splitBoxProps2[1];
  var _useTheme = (0, _Theme.useTheme)(),
    theme = _useTheme.theme;
  return /*#__PURE__*/_react.default.createElement(_Modal.ModalBase, _extends({
    onClose: onClose,
    style: isMounted ? {
      backgroundColor: theme.effects.backdrop,
      transition: "background-color 250ms"
    } : {
      backgroundColor: "transparent"
    },
    dialogProps: {
      width: width !== null && width !== void 0 ? width : 480
    }
  }, modalProps), /*#__PURE__*/_react.default.createElement(_ModalDialogContent.ModalDialogContent, _extends({
    footer: footer,
    hasLogo: hasLogo,
    leftPanel: leftPanel,
    onClose: onClose,
    rightPanel: rightPanel,
    title: title,
    header: header,
    width: "100%",
    style: isMounted ? {
      opacity: 1,
      transition: "opacity 250ms, transform 250ms"
    } : {
      opacity: 0,
      transform: "translateY(10px)"
    }
  }, boxProps), children));
};
exports.ModalDialog = ModalDialog;
ModalDialog.displayName = "ModalDialog";
//# sourceMappingURL=ModalDialog.js.map